import { render, staticRenderFns } from "./cooperat.vue?vue&type=template&id=c421fca2&scoped=true&"
import script from "./cooperat.vue?vue&type=script&lang=js&"
export * from "./cooperat.vue?vue&type=script&lang=js&"
import style0 from "./cooperat.vue?vue&type=style&index=0&id=c421fca2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c421fca2",
  null
  
)

export default component.exports